import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalString,
    optionalUuid,
    requiredNumber,
    requiredString,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createEntriesAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        logged_time: requiredString(),
        horse_id: optionalUuid(),
        invoice_id: optionalUuid(),
        event_id: optionalUuid(),
        title: optionalString(),
        notes: optionalString(),
        private_notes: optionalString(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
    });

export const createEntriesUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createEntriesAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.entries,
    );

export const createEntriesDeleteSchema = () => createDeleteSchema();

export const createEntriesSchemas = () => ({
    add: createEntriesAddSchema(),
    update: createEntriesUpdateSchema(),
    delete: createEntriesDeleteSchema(),
});
